import { loadHelpCenterArticlePageData } from '@aboutyou/legacy-shared/src/pages/HelpCenter/loadHelpCenterPageData'
import { isomorphicRedirectTo } from 'helpers/navigation'
import { FetchProps } from 'helpers/redial'
import { report } from 'helpers/reporter'
import { runInAction, transaction } from 'mobx'

export default {
  fetch: async ({ store, service, params }: FetchProps) => {
    const articleId = parseInt(params.articleId, 10)
    runInAction(() => {
      store.helpCenterArticlePage.loading = true
      store.helpCenterArticlePage.activeArticle = undefined
      store.helpCenterArticlePage.relatedArticles = undefined
      store.helpCenterArticlePage.activeSectionId = undefined
    })

    try {
      if (isNaN(articleId)) {
        isomorphicRedirectTo({
          to: `/404`,
          urlManager: store.urlManager,
          router: store.router,
          status: 404,
        })
      }

      const articlePageData = await loadHelpCenterArticlePageData(
        service.helpCenter,
        store.localeStore.locale,
        articleId,
      )

      transaction(() => {
        store.helpCenterArticlePage.reset({
          ...articlePageData,
          sections: articlePageData?.sections ?? [],
          articleId,
          activeSectionId: articlePageData.activeArticle.section_id,
        })

        store.helpCenterArticlePage.loading = false
      })
    } catch (error) {
      report('failed to load help center data for article page', { error })

      isomorphicRedirectTo({
        to: `/h`,
        urlManager: store.urlManager,
        router: store.router,
      })

      runInAction(() => {
        store.helpCenterArticlePage.loading = false
      })
    }
  },
}
